import { useMutation } from "react-query";
import { getDSSForm, getDSSFormValues } from "../services/dss.service";

export function useGetDSSForm (){
    return useMutation((p: {locale: string}) => getDSSForm(p.locale))
}

export function useGetDssFormValues (){
    return useMutation(_ => getDSSFormValues())
}